import { render, staticRenderFns } from "./Anasayfa.vue?vue&type=template&id=0c070ab0&"
import script from "./Anasayfa.vue?vue&type=script&lang=js&"
export * from "./Anasayfa.vue?vue&type=script&lang=js&"
import style0 from "./Anasayfa.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Anasayfa.vue"
export default component.exports